module.exports = __webpack_public_path__ + "static/img/fanghongbo.7db305b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/fanghongbo.png
// module id = CMVu
// module chunks = 0